import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dec891a4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec891a4')) {
      api.createRecord('dec891a4', component.options)
    } else {
      api.reload('dec891a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dec891a4&", function () {
      api.rerender('dec891a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/store/fullscreen/index.vue"
export default component.exports